import ReactDOM from "react-dom";
import { BusienssControlNames, GenericBusinessControl } from "../Binding/GenericBusinessControl";
import { UserContext } from "../Definitions/UserContext";
import React from "react";
import { MembershipPlaceHolder, PackagesPlaceHolder } from "../Binding/BusinessPlaceholderData";

export function OpenToComponent (userContext:UserContext,type:string,id:string) {


    let dom = document.getElementById("divcontent");

    let mainContent = dom?.children[0] as HTMLElement;

    let stencil:any = null;
    console.log("type...");
    switch(type){
 
        case BusienssControlNames.packages:
        stencil = {...PackagesPlaceHolder};
        break;

        case BusienssControlNames.memberships:
        stencil = {...MembershipPlaceHolder};
        break;
        default:
            break;
    }

    if(mainContent){
        
        document.body.scrollTo(0,0);
        window.history.pushState({}, "", window.location.href);
        window.addEventListener('popstate', function(event) { // make back button reload page
            window.location.reload();
        });


        ReactDOM.render( <div className="w-full flex-row justify-center align-start" style={{padding:"100px 10px",minHeight:"60vh"}}><div style={{maxWidth:"1200px",width:"100%"}}><GenericBusinessControl inData={stencil} dataKey={type} userContext={userContext}  layout="1" filters={id}  /></div></div>, mainContent);
        
    }

}